module.exports = __webpack_public_path__ + "img/product-traffic-sales.83113334.jpg";